export const createPollingBroadcastChannel = (connectionId, onMessage) => {
  if (BroadcastChannel) {
    const channel = new BroadcastChannel(`calling-cross-tab-polling-channel-${connectionId}`);
    if (onMessage) channel.addEventListener('message', onMessage);
    return channel;
  }
  return undefined;
};